import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/salesContent';
import { trackInitiateCheckout } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  note?: string;
  pulse?: boolean;
};
export function CtaButton({
  children,
  note,
  pulse = true
}: CtaButtonProps) {
  const reduceMotion = useReducedMotion();
  const shouldPulse = pulse && !reduceMotion;
  return <div className="flex w-full flex-col items-center" data-id="element-23" data-mp="llqv76kplu22">
      <motion.a href={CHECKOUT_URL} onClick={trackInitiateCheckout} animate={shouldPulse ? {
      scale: [1, 1.025, 1]
    } : undefined} transition={shouldPulse ? {
      duration: 2.4,
      ease: 'easeInOut',
      repeat: Infinity
    } : undefined} className="group inline-flex w-full max-w-2xl items-center justify-center gap-3 rounded-xl bg-accent px-6 py-5 text-center text-base font-extrabold uppercase tracking-wide text-canvas shadow-lg shadow-accent/20 transition-colors duration-150 ease-out hover:bg-accent-hover focus:outline-none focus-visible:ring-4 focus-visible:ring-accent/40 md:text-lg" data-id="element-24" data-mp="ll7bbkbi0vle">
        <span data-id="element-25" data-mp="3a0u6k47r5xqw">{children}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-26" data-mp="3exb41p0udogn" />
      </motion.a>
      {note && <p className="mt-4 text-center text-sm text-muted md:text-base" data-id="element-27" data-mp="3jukp6sh77dyo">{note}</p>}
    </div>;
}